import { TableTdProps } from "../../../types";

export const TableTd = <TData,>({
  col,
  item,
  rowIdx,
  colIdx,
  ...props
}: TableTdProps<TData>) => (
  <div {...props}>
    <div
      className="flex h-full items-center truncate"
      style={{
        userSelect: "text",
        cursor: "text",
      }}
    >
      {typeof col.content === "function"
        ? col.content(item, rowIdx)
        : col.content}
    </div>
  </div>
);
